import { ProductCollections } from 'types/model/product-collections';

import { get } from '../base';

export function getCollectionsByProductId({ id }: { id: string }): Promise<ProductCollections> {
  return get('v5/collections', { searchParams: { productId: id } }).json();
}
